import ReactDOM from "react-dom/client";
import { store } from "./reduxSetup/store";
import { Provider } from "react-redux";
import "./index.css";
import App from "./containers/App/App";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    <App />
  </Provider>
);

reportWebVitals();
